import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService, httpHeaders } from '../../client.service';

import { Documents } from './legal.model';
import { XotaMode } from '@store';

@Injectable()
export class LegalApi {
  private readonly baseUrl = 'legal/v3';
  constructor(private clientService: ClientService) {}

  /**
   * Returns list of app documents
   * @param appId
   * @param languageCode
   */
  getAppDocuments(appId: string, languageCode: string): Observable<Documents> {
    const endpoint = `${this.baseUrl}/apps/${appId}/documents?country=${languageCode}`;

    return this.clientService.get(endpoint, {}, httpHeaders);
  }

  /**
   * Returns list of updated documents for specific language
   * @param appId
   * @param country
   * @param languageCode
   */
  getUpdatedDocuments(appId: string, country: string, languageCode: string): Observable<Documents> {
    httpHeaders.set('Accept-Language', languageCode);
    const endpoint = `${this.baseUrl}/apps/${appId}/documents/updated?country=${country}`;

    return this.clientService.get(endpoint, {}, httpHeaders);
  }

  /**
   * Set user agreement on document
   * @param userId
   * @param revisionId
   */
  createDocumentAgreement(userId: string, revisionId: string): Observable<any> {
    const endpoint = `${this.baseUrl}/users/${userId}/document-agreements`;

    return this.clientService.post(endpoint, { revisionId }, httpHeaders);
  }

  /**
   * Shows xOTA agreement status for a given installation
   * @param appId
   * @param installationId
   */
  documentAgreementXota(appId: string, installationId: number): Observable<{ xotaMode: XotaMode }> {
    const endpoint = `${this.baseUrl}/document-agreements/xota`;

    return this.clientService.get(
      endpoint,
      {
        appId,
        installationId,
      },
      httpHeaders
    );
  }
}
